import { Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService } from '../api/api.service';
import { ApiWebSocketService } from '../api/api.web-socket.service';
import { login, logout } from '../store/auth/auth.actions';

export function saveTokens(
  tokens: object | any,
  wsService?: ApiWebSocketService
): boolean {
  if (wsService) {
    wsService.refreshWebsocketToken(tokens.accessToken);
  }
  Object.keys(tokens).forEach((field: string) => {
    localStorage.setItem(field, tokens[field]);
  });
  return true;
}

export function checkTokens(
  type: 'resume' | 'login',
  store: Store,
  api: ApiService,
  router: Router,
  query?: Params
): boolean {
  if (localStorage['accessToken'] && localStorage['refreshToken']) {
    if (new Date(+localStorage['expirationAccessToken']) > new Date()) {
      store.dispatch(login({ status: 'authorized' }));
      if (type === 'login') {
        return true;
      } else {
        router.navigate(['/city']);
      }
    } else {
      if (new Date(+localStorage['expirationRefreshToken']) > new Date()) {
        api
          .auth('refresh', localStorage['refreshToken'])
          .subscribe((res): boolean | any => {
            if (res) {
              saveTokens(res);
              router.navigate(['/city']);
            }
          });
      } else {
        store.dispatch(logout());
      }
    }
  }
  // if (type === 'resume') {
  //   localStorage.clear();
  // }
  if (type === 'login') {
    if (query?.accessToken) {
      if (saveTokens(query)) {
        location.replace('/city');
        return true;
      } else {
        store.dispatch(login({ status: 'unauthorized' }));
      }
    }
    [
      'expirationRefreshToken',
      'expirationAccessToken',
      'accessToken',
      'refreshToken',
    ].forEach((key) => localStorage.removeItem(key));
    router.navigate(['/auth']);
    return false;
  } else {
    return true;
  }
}
